// Copyright (c) 2015-present Mattermost, Inc. All Rights Reserved.
// See LICENSE.txt for license information.

import React from 'react';
import ContainerLoader from 'fe-shared-lib/src/components/UIComponent/ContainerLoader';
import ErrorBoundary from 'src/components/layout/ErrorBoundary';

// Shared centered loader — the common "chunk is downloading" (Suspense) fallback for every
// lazy route, matching the community-gate and route data-fetch loaders.
export function makeAsyncComponent(displayName, LazyComponent, fallback = <ContainerLoader region="full" />, childLevel = 2) {
	// Named function (not arrow) so React error stacks show `displayName` instead of a minified name like `k`.
	function AsyncRouteComponent(props) {
		return (
			<ErrorBoundary childLevel={childLevel} resetKey={props.location?.pathname}>
				<React.Suspense fallback={fallback}>
					<LazyComponent {...props} />
				</React.Suspense>
			</ErrorBoundary>
		);
	}
	AsyncRouteComponent.displayName = displayName;
	return AsyncRouteComponent;
}
